import { Link } from '@router'
import styles from './Toggle.module.css'

// One segmented option. An `href` makes it a router <Link> (selection
// derived from the route); otherwise `onSelect` makes it a <button>
// (selection derived from state). `active` drives the pressed styling.
export type ToggleOption = {
	key: string
	label: string
	active: boolean
	href?: string
	onSelect?: () => void
}

type Props = {
	ariaLabel: string
	options: ToggleOption[]
}

// Shared pill-segmented toggle. Used by the todo Personal/Family switch and
// the activities List/Map switch so they stay visually identical.
export const Toggle = ({ ariaLabel, options }: Props) => (
	<div className={styles.toggle} role="group" aria-label={ariaLabel}>
		{options.map((opt) =>
			opt.href !== undefined ? (
				<Link
					key={opt.key}
					href={opt.href}
					className={styles.option}
					aria-pressed={opt.active}
				>
					{opt.label}
				</Link>
			) : (
				<button
					key={opt.key}
					type="button"
					className={styles.option}
					aria-pressed={opt.active}
					onClick={opt.onSelect}
				>
					{opt.label}
				</button>
			),
		)}
	</div>
)
